<template>
  <div class="flex mr-4">
    <div class="caption fw-normal text-xs-right">
      {{ copyrightText.replace('$$year$$', new Date().getFullYear()) }}
    </div>
  </div>
</template>

<script>
import AppConfig from 'Constants/AppConfig';

export default {
  data() {
    return {
      copyrightText: AppConfig.copyrightText
    };
  }
};
</script>
